import FloatingLabel from './FloatingLabel'

import { Input } from '@/components/ui/input'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  className?: string
}

const LabeledInputText = ({ label, className, ...inputProps }: Props) => (
  <FloatingLabel label={label} className={className}>
    <Input {...inputProps} />
  </FloatingLabel>
)

export default LabeledInputText
